import { Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
//import { FormControl, FormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeMultiselectDialog } from '../employee-popup/employee-popup.component';
import { process, State } from '@progress/kendo-data-query';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService} from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    CheckCall,
    LoadStatus,
    SearchQuoteOrderLine
} from '../../models/models';

@Component({
    selector: 'quoteorderline-grid',
    templateUrl: './quoteorderline-grid.component.html',
    standalone: false
})
export class QuoteOrderLineGrid implements OnDestroy, OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() pageType: string = "";
    @Input() readonly: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Output() onAddNew = new EventEmitter<any>();
    @Output() onSelect = new EventEmitter<any>();
    @Output() onEditCarrierReps = new EventEmitter<any>();
    @Output() onEditCarrierServices = new EventEmitter<any>();
    @Output() onSetLoadTags = new EventEmitter<any>();
    @Output() onAddOffer = new EventEmitter<any>();
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public lineGrid!: GridComponent;
    @ViewChild('inputFile', { static: false }) public inputFile!: ElementRef;

    public dataSheet = new Subject();

    public quoteOrderLineList: SearchQuoteOrderLine[] = [];
    public quoteOrderLineID: number = 0;
    private loadStatusList: LoadStatus[] = [];
    public isCSRManager: boolean = false;
    public isEdit: boolean = false;
    public isEditNotificationSchedule: boolean = false;
    public isViewDocuments: boolean = false;

    public recordLockAction: string = "";
    public recordLockSource: string = "";
    private recordID: number = 0;
    private handledLoad: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    private handledRateIndex: string = "";

    public gridState: State = { skip: 0, take: 0, sort: [{ dir: 'asc', field: 'legNumber' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private erpService: ERPService, private orderService: OrderService, public dialog: MatDialog,
        private notificationService: NotificationService, private ngZone: NgZone,
        private recordLockService: RecordLockService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.isCSRManager = this.getIsCSRManager();
        this.orderService.getLoadStatuses().subscribe(result => {
            this.loadStatusList = result.resultCollection;
        });
        //this.getSearchQuoteOrderLines();
        this.initRecordLock();
    }

    ngOnChanges() {
        this.getSearchQuoteOrderLines();
        //console.log("ngOnChanges");
    }

    ngOnDestroy() {
        //this.recordLockService.resetRecordLock();
    }

    private getIsCSRManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Carrier Sales Manager') > -1) return true;
        }

        return false;
    }

    private getSearchQuoteOrderLines() {
        this.quoteOrderLineID = 0;
        this.utilService.isLoading = true;
        this.isEdit = false;
        this.isEditNotificationSchedule = false;
        this.isViewDocuments = false;
        this.quoteOrderLineList.length = 0;
        this.orderService.getSearchQuoteOrderLinesByQuoteOrderID(this.quoteOrderID).subscribe(result => {
            this.utilService.isLoading = false;
            this.quoteOrderLineList = result.resultCollection;
            this.setGrid();
            //console.log("quoteOrderLineList:quoteOrderID", this.quoteOrderID, this.quoteOrderLineList.length);
        });
    }

    private setGrid() {
        this.gridData = process(this.quoteOrderLineList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.lineGrid == null) return;
            this.lineGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setGrid();
        //this.gridData = process(this.quoteOrderLineList, this.gridState);
    }

    public addNew(line: SearchQuoteOrderLine) {
        var evt: any = {
            quoteOrderLineID: line.quoteOrderLineID,
            orderStopID: 0
        };
        //console.log("quoteorderline-grid:addNew", evt, line);
        this.onAddNew.emit(evt);
    }

    public edit(line: SearchQuoteOrderLine) {
        //console.log("edit:quoteOrderLineID", line.quoteOrderLineID, line);
        this.recordLockAction = "editQuoteOrderLine";
        this.handledLoad = line;
        //this.handleRecordLock(line.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", line.quoteOrderID, this.recordLockSource);
    }

    public updateMiles(line: SearchQuoteOrderLine) {
        this.utilService.isLoading = true;
        this.orderService.updateQuoteOrderLineMilesByID(line.quoteOrderLineID).subscribe(result => {
            this.utilService.isLoading = false;
            this.getSearchQuoteOrderLines();
            //console.log("updateMiles", result);
        });
    }

    public editCarrierReps(line: SearchQuoteOrderLine) {
        //console.log("editCarrierReps:quoteOrderLineID", line.quoteOrderLineID, line);
        this.onEditCarrierReps.emit(line.quoteOrderLineID);
    }

    public editCarrierServices(quoteOrderLineID: number) {
        this.onEditCarrierServices.emit(quoteOrderLineID);
    }

    public editNotificationSchedule(line: SearchQuoteOrderLine) {
        this.quoteOrderLineID = line.quoteOrderLineID;
        this.isEditNotificationSchedule = true;
    }

    public deleteNotificationSchedule(line: SearchQuoteOrderLine) {
        var idx = this.quoteOrderLineList.findIndex(c => c.quoteOrderLineID == line.quoteOrderLineID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to remove this notification schedule?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.orderService.deleteQuoteOrderLineNotificationScheduleByQuoteOrderLineID(line.quoteOrderLineID).subscribe(result => {
                this.getSearchQuoteOrderLines();
            });
        });
    }

    public viewDocuments(line: SearchQuoteOrderLine) {
        this.quoteOrderLineID = line.quoteOrderLineID;
        this.isViewDocuments = true;
    }

    public cancelViewDocuments() {
        this.quoteOrderLineID = 0;
        this.isViewDocuments = false;
    }

    public createRoundTrip(line: SearchQuoteOrderLine) {
        this.recordLockAction = "createRoundTrip";
        this.handledLoad = line;
        //this.handleRecordLock(line.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", line.quoteOrderID, this.recordLockSource);
    }

    private allowCreateRoundTrip(line: SearchQuoteOrderLine) {
        //console.log("createRoundTrip", line.quoteOrderLineID, line);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Create Round Trip?',
            message: 'You are about to create a round trip for load #' + line.legNumber + '.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Loads Grid Create Round Trip");
            this.utilService.isLoading = true;
            this.orderService.createRoundTrip(line.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error creating round trip: " + result.message, "ERROR: Create Round Trip");
                }
                else {
                    this.notificationService.showSuccess("Successfully created round trip", "SUCCESS: Create Round Trip");
                    console.log("createRoundTrip", result, line);
                }
                this.refreshAfterEdit();
            });
        });
    }

    public sendEmail(line: SearchQuoteOrderLine) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showNotes: true,
            showCheckCallNotes: false,
            showSystemNotes: false
        }

        const dialogRef = this.dialog.open(EmployeeMultiselectDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result == null ||
                ((result.selectedEmployees == null || result.selectedEmployees.length < 1) &&
                    (result.selectedGroupId == null || result.selectedGroupId < 1))) return;

            var emails = '';
            if (result.selectedEmployees != null) {
                result.selectedEmployees.forEach(e => {
                    emails += e.email + '|';
                });
            }

            if (result.selectedEmails != null) {
                emails += result.selectedEmails + '|';
            }

            this.orderService.sendQuoteOrderLineEmail(line.quoteOrderLineID, emails, result.selectedGroupId, "", result.notes, false, false, "", false).subscribe(emailResult => {
                var ok = emailResult;
            });
        });
    }

    public addOffer(line: SearchQuoteOrderLine) {
        this.recordLockAction = "addOffer";
        this.handledLoad = line;
        //this.handleRecordLock(line.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", line.quoteOrderID, this.recordLockSource);
    }

    public canEdit(load: SearchQuoteOrderLine) {
        var ret: boolean = false;
        //if (load.loadStatus == 'Planned' || load.loadStatus == 'Available') {
        //    ret = true;
        //}
        if (load.loadStatus != 'Completed' && load.loadStatus != 'Canceled') {
            ret = true;
        }
        return ret;
    }

    public canCreateRoundTrip(load: SearchQuoteOrderLine) {
        var ret: boolean = false;
        //if (this.quoteOrderLineList.length == 1 && load.loadStatus == 'Planned' || load.loadStatus == 'Available') {
        //    ret = true;
        //}
        if (this.quoteOrderLineList.length == 1 && load.loadStatus != 'Completed' && load.loadStatus != 'Canceled') {
            ret = true;
        }
        return ret;
    }

    public canAddOffer(load: SearchQuoteOrderLine) {
        var ret: boolean = false;
        //if (this.quoteOrderLineList.length == 1 && load.loadStatus == 'Planned' || load.loadStatus == 'Available') {
        //    ret = true;
        //}
        if (this.quoteOrderLineList.length > 0 && (load.carrierID == null || load.carrierID == 0)) {
            ret = true;
        }
        return ret;
    }

    public canCompleteStops(load: SearchQuoteOrderLine) {
        var canComplete: boolean = false;
        // Check previous load
        var lst = this.quoteOrderLineList.filter(t => t.legNumber == load.legNumber - 1);
        var isPreviousComplete: boolean = true;
        if (lst.length > 0) {
            if (lst[0].loadStatus != "Completed") {
                isPreviousComplete = false;
            }
        }
        var loadStatus = this.loadStatusList.find(t => t.loadStatusID == load.loadStatusID);
        if (isPreviousComplete && loadStatus != null && loadStatus.inTransitInd == true) {
            canComplete = true;
        }
        return canComplete;
    }

    public completeStops(line: SearchQuoteOrderLine) {
        this.recordLockAction = "completeStops";
        this.handledLoad = line;
        //this.handleRecordLock(line.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", line.quoteOrderID, this.recordLockSource);
    }

    private allowCompleteStops(load: SearchQuoteOrderLine) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Complete Stops?',
            message: 'This will complete the remaining stops for this load.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Loads Grid Complete Stops");
            this.utilService.isLoading = true;
            this.orderService.saveAutoCompleteQuoteOrderLine(load.quoteOrderLineID, parseInt(localStorage.getItem('EmployeeId')!)).subscribe(result => {
                console.log("completeStops", result);

                if (result.message != "OK") {
                    this.notificationService.showError("Error completing stops: " + result.message, "ERROR: Complete Stops");
                }
                else {
                    this.notificationService.showSuccess("Successfully completed stops", "SUCCESS: Complete Stops");
                    this.addCompleteStopsCheckCall(load);
                    if (load.quoteOrderLineID > 0) {
                        this.orderService.exportQuoteOrder(load.quoteOrderLineID).subscribe(exportedOrder => {
                            console.log("exportQuoteOrder:result", exportedOrder);
                        });
                    }
                    console.log("completeStops", result);
                }
                this.refreshAfterEdit();
            });
        });
    }

    private addCompleteStopsCheckCall(load: SearchQuoteOrderLine) {
        var checkCall = this.getNewCheckCall(load);
        checkCall.orderEventScheduleID = 0;
        var modifiedByName = localStorage.getItem('EmployeeFullName')!;
        var modifiedDate = formatDate(new Date(), "MMM d yyyy h:mmaaa", "en-US");
        checkCall.comment = "Stops Completed by " + modifiedByName + " @ " + modifiedDate;
        this.saveCheckCall(checkCall, true);
    }

    private getNewCheckCall(load: SearchQuoteOrderLine) {
        var newCheckCall = {
            quoteOrderLineId: load.quoteOrderLineID,
            legHeaderNumber: load.legNumber, //quoteOrderLine.apiLoadID == null ? 0 : quoteOrderLine.apiLoadId,
            checkCallAction: 'Complete Stops',
            status: 'HIST',
            assignType: 'CAR',
            assignId: load.carrierCode,
            cityId: 0,
            comment: '',
            dateOfCall: new Date(),
            eventCode: "CHK",
            tractorNumber: 'UNKNOWN',
            lateInd: false,
            cautionInd: false,
            createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            createdDate: new Date()
        } as CheckCall;
        return newCheckCall;
    }

    private saveCheckCall(checkCall: CheckCall, isUTCOffset: boolean) {
        this.utilService.isLoading = true;
        if (isUTCOffset) {
            checkCall.dateOfCall = this.utilService.getDateAsUTC(checkCall.dateOfCall);
        }
        this.orderService.saveCheckCall(checkCall).subscribe(result => {
            this.utilService.isLoading = false;
            //this.checkCalls.push(result);
            //this.setCheckCallGrid();
            //this.getCheckCalls();
        });
    }

    public setTags(line: SearchQuoteOrderLine) {
        //console.log("setTags:quoteOrderLineID", line.quoteOrderLineID, line);
        this.onSetLoadTags.emit(line.quoteOrderLineID);
    }

    public openMacropointURL(line: SearchQuoteOrderLine) {
        this.erpService.getMacropointLink(line.quoteOrderLineID).subscribe(result => {
            var url = result.resultCollection[0];
            if (url == "") {
                this.notificationService.showWarning("System failed to retrieve link from Macropoint. Please make sure this load is setup in their system.", "WARNING: Macropoint Link");
            }
            else {
                window.open(url, "_blank");
            }
        });
        // this.orderService.getMacropointUrlByLineId(line.quoteOrderLineID).subscribe(result => {
        //     if (result.length > 0) {
        //         window.open(result, "_blank");
        //     }
        //     else {
        //         this.notificationService.showWarning("Macropoint URL not found", "WARNING: Macropoint URL");
        //     }
        //     //console.log("openMacropointURL", result);
        // });
    }

    public setQuoteOrderLineRateIndex(line: SearchQuoteOrderLine, rateIndex: string) {
        this.recordLockAction = "setQuoteOrderLineRateIndex";
        this.handledLoad = line;
        this.handledRateIndex = rateIndex;
        //this.handleRecordLock(line.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", line.quoteOrderID, this.recordLockSource);
    }

    private allowSetQuoteOrderLineRateIndex(line: SearchQuoteOrderLine, rateIndex: string) {
        console.log("setQuoteOrderRateIndex", line.quoteOrderLineID, line);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Change Rate Index',
            message: 'You are about to set this load to ' + rateIndex + ': Load #' + line.legNumber + '.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.isLoading = true;
            this.orderService.setQuoteOrderLineRateIndex(line.quoteOrderLineID, rateIndex).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error setting rate index " + rateIndex + ": " + result.message, "ERROR: Set Rate Index");
                }
                else {
                    this.notificationService.showSuccess("Successfully set rate index " + rateIndex, "SUCCESS: Set Rate Index");
                    console.log("setQuoteOrderLineRateIndex", rateIndex, result, line);
                }
                this.refreshAfterEdit();
            });
        });
    }

    public setQuoteOrderLineLoadStatus(line: SearchQuoteOrderLine, loadStatus: string) {
        //console.log("setQuoteOrderLineLoadStatus", line.quoteOrderLineID, line);
        //let dialogRef = this.dialog.open(ConfirmDialog, {
        //    data: {
        //        header: 'Change Load Status',
        //        message: 'You are about to set this load to ' + loadStatus + ': Load #' + line.legNumber + '.  Confirm to continue.'
        //    }
        //});

        //dialogRef.afterClosed().subscribe(dialogResult => {
        //    if (!dialogResult) return;

        //    this.utilService.isLoading = true;
        //    this.orderService.setQuoteOrderLineLoadStatus(line.quoteOrderLineID, loadStatus).subscribe(result => {
        //        this.utilService.isLoading = false;
        //        if (result.message != "OK") {
        //            this.notificationService.showError("Error setting load status " + loadStatus + ": " + result.message, "ERROR: Set Load Status");
        //        }
        //        else {
        //            this.notificationService.showSuccess("Successfully set load status " + loadStatus, "SUCCESS: Set Load Status");
        //            console.log("setQuoteOrderLineLoadStatus", loadStatus, result, line);
        //        }
        //        this.refreshAfterEdit();
        //    });
        //});
        this.utilService.isLoading = true;
        this.orderService.setQuoteOrderLineLoadStatus(line.quoteOrderLineID, loadStatus).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.message != "OK") {
                this.notificationService.showError("Error setting load status " + loadStatus + ": " + result.message, "ERROR: Set Load Status");
            }
            else {
                this.notificationService.showSuccess("Successfully set load status " + loadStatus, "SUCCESS: Set Load Status");
                console.log("setQuoteOrderLineLoadStatus", loadStatus, result, line);
            }
            this.refreshAfterEdit();
        });
    }

    public delete(line: SearchQuoteOrderLine) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'You are about to delete load #' + line.legNumber + '.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.isLoading = true;
            this.orderService.deleteQuoteOrderLine(line.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error deleting load: " + result.message, "ERROR: Delete Load");
                }
                else {
                    this.notificationService.showSuccess("Successfully deleted load", "SUCCESS: Delete Load");
                    console.log("deleteQuoteOrderLine", result, line);
                }
                this.refreshAfterEdit();
            });
        });
    }

    private refreshAfterEdit() {
        if (this.pageType != "orderentry") {
            this.recordLockAction = "";
            this.recordLockService.clearRecordLock("QuoteOrder", this.recordID, this.recordLockSource);
        }
        this.getSearchQuoteOrderLines();
        this.onRefresh.emit();
    }

    private initRecordLock() {
        this.recordLockAction = "";
        this.recordLockSource = "Loads Grid";
        if (this.pageType == "orderentry") {
            //this.recordLockSource = "Order Entry: Loads Grid";
            this.recordLockSource = "Order Entry";
        }
        else if (this.pageType == "procurement") {
            this.recordLockSource = "Procurement";
        }
        else if (this.pageType == "tracking") {
            this.recordLockSource = "Tracking Dashboard";
        }

        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            //console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "editQuoteOrderLine") {
                    this.isEdit = true;
                    this.onSelect.emit(this.handledLoad.quoteOrderLineID);
                    this.handledLoad = {} as SearchQuoteOrderLine;
                    this.recordID = 0;
                }
                else if (this.recordLockAction == "addOffer") {
                    this.onAddOffer.emit(this.handledLoad.quoteOrderLineID);
                    this.handledLoad = {} as SearchQuoteOrderLine;
                    this.recordID = 0;
                }
                else if (this.recordLockAction == "createRoundTrip") {
                    this.allowCreateRoundTrip(this.handledLoad);
                    this.handledLoad = {} as SearchQuoteOrderLine;
                    this.recordID = 0;
                }
                else if (this.recordLockAction == "completeStops") {
                    this.allowCompleteStops(this.handledLoad);
                    this.handledLoad = {} as SearchQuoteOrderLine;
                    this.recordID = 0;
                }
                else if (this.recordLockAction == "setQuoteOrderLineRateIndex") {
                    this.allowSetQuoteOrderLineRateIndex(this.handledLoad, this.handledRateIndex);
                    this.handledLoad = {} as SearchQuoteOrderLine;
                    this.handledRateIndex = "";
                    this.recordID = 0;
                }
                this.recordLockAction = "";
            }
        });
    }
}
